// extracted by mini-css-extract-plugin
module.exports = {"numItems":"numItems--3ZSom","cart":"cart--1Clp7","icon":"icon--1IEhi","timer":"timer--3L64Q","admin":"admin--3h8jO"};